import React from 'react';

const SitTag = () => {
  return (
    <div className="sit-tag">
      Ambiente SIT
    </div>
  )
}

export default SitTag
